import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useAuthStore } from "../../../stores/authStore";
import { LoginFormValues, loginSchema } from "../loginSchema";
import useLoginLockout from "./useLoginLockout";

const EMAIL_STORAGE_KEY = "email";

const getInitialEmail = () => {
    const params = new URLSearchParams(window.location.search);
    const queryEmail = params.get("email");

    if (queryEmail) return queryEmail;

    return localStorage.getItem(EMAIL_STORAGE_KEY) ?? "";
};

const useLoginForm = () => {
    const login = useAuthStore((s) => s.login);
    const { countdownLabel, isLocked, showLockedAlert } = useLoginLockout();
    const [showPassword, setShowPassword] = useState(false);
    const [saveEmail, setSaveEmail] = useState(
        () => Boolean(localStorage.getItem(EMAIL_STORAGE_KEY)),
    );

    const form = useForm<LoginFormValues>({
        resolver: yupResolver(loginSchema),
        defaultValues: {
            email: getInitialEmail(),
            password: "",
        },
    });

    useEffect(() => {
        form.reset({
            email: getInitialEmail(),
            password: "",
        });
    }, [form]);

    const onSubmit = (values: LoginFormValues) => {
        if (isLocked) {
            showLockedAlert();
            return;
        }

        login(values);

        if (saveEmail) {
            localStorage.setItem(EMAIL_STORAGE_KEY, values.email);
            return;
        }

        localStorage.removeItem(EMAIL_STORAGE_KEY);
    };

    return {
        countdownLabel,
        form,
        isLocked,
        onSubmit,
        saveEmail,
        setSaveEmail,
        showPassword,
        togglePasswordVisibility: () => {
            setShowPassword((previousState) => !previousState);
        },
    };
};

export default useLoginForm;
